import { createRequest } from '@savgroup-front-common/core/services/request';

export const LOAD_FILE_INFO = createRequest('FILE_INFO/LOAD_FILE_INFO');
